import axios from 'axios';

const apiClient = axios.create({
    baseURL: '/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true, // Important for cookies
});

// Add CSRF token to requests
apiClient.interceptors.request.use(config => {
    const token = document.querySelector('meta[name="csrf-token"]');
    if (token) {
        config.headers['X-CSRF-TOKEN'] = token.getAttribute('content');
    }
    return config;
});

// We'll use this to make sure we have a CSRF cookie before making any state-changing requests.
export const getCsrfCookie = () => {
    return axios.get('/sanctum/csrf-cookie');
};

export default apiClient;
